import React from "react";
import HelpCircle from "/src/svg/help-circle.svg";
import Icon, {IconSVG} from "../../icon/Icon";
import Tooltip from "../../tooltip/Tooltip";

import {css} from "/src/utils/utils";
import translate from "/src/utils/translate";

import * as styles from "./label.module.scss";

interface Props {
  ariaHidden?: boolean;
  classes?: string;
  darkMode?: boolean;
  disabled?: boolean;
  id?: string;
  label?: string;
  labelHtmlSanitized?: string; // Pre-sanitized HTML from build-time
  required?: boolean;
  tooltipContent?: string;
  tooltipIcon?: IconSVG;
  tooltipPlainContent?: string;
}

export default function Label(props: Props) {
  const {
    ariaHidden = false,
    classes = "",
    darkMode = false,
    disabled = false,
    id = "",
    label = "",
    labelHtmlSanitized,
    required = false,
    tooltipContent,
    tooltipIcon = HelpCircle,
    tooltipPlainContent,
  } = props;

  return (
    <div className={css(styles.wrapper, classes)}>
      <span className={styles.label__display}>
        {labelHtmlSanitized ? (
          <span
            aria-hidden={ariaHidden}
            id={id}
            className={css(
              styles.label,
              darkMode ? styles.labelDark : "",
              disabled ? styles.labelDisabled : "",
              classes
            )}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: labelHtmlSanitized,
            }}
          />
        ) : (
          <span
            aria-hidden={ariaHidden}
            id={id}
            className={css(
              styles.label,
              darkMode ? styles.labelDark : "",
              disabled ? styles.labelDisabled : "",
              classes
            )}
          >
            {label}
          </span>
        )}

        {required ? (
          <span aria-hidden="true" tabIndex={-1} className={styles.label}>
            *
          </span>
        ) : null}
      </span>

      {tooltipIcon && tooltipContent != null && (
        <Tooltip
          wrapInAButton
          id={`${id}-helper-tooltip`}
          content={tooltipContent}
          triggerLabel={`${translate("helper tooltip")} - ${
            tooltipPlainContent != null ? tooltipPlainContent : tooltipContent
          }`}
          triggerElem={
            <Icon
              svg={tooltipIcon}
              role="presentation"
              classes={css(
                styles.label__tooltipIcon,
                darkMode ? styles.label__tooltipIconDark : ""
              )}
            />
          }
        />
      )}
    </div>
  );
}
